import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import TextInput from "../../widgets/TextInput";
import updateStudente from '../../services/updateStudente';
import updateCorsiStudente from '../../services/updateCorsiStudente';
import updateCorsiRitiroStudente from "../../services/updateCorsiRitiroStudente";
import getSetting from '../../services/getSetting';
import getStudenti from '../../services/getStudenti';
import getCorsi from '../../services/getCorsi';
import FixButton from "../../widgets/Button";
import SelectInput from "../../widgets/SelectInput";
import getUtente from "../../services/getUtente";
import sendMail from "../../services/sendMail";
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../utils/Locales";
import { studentCredenzialiMail } from '../../utils/consts';
import getClient from "../../services/getClient";
import Utils from "../../utils/utils";

let t = translateString;

export default class EditStudente extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.selectRef = React.createRef();
    this.selectCoursesRitiratiRef = React.createRef();
    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      nome: '',
      cognome: '',
      mail: '',
      mail2Tipo: '',
      mail2: '',
      indirizzo: '',
      citta: '',
      codiceFiscale: '',
      telefono: '',
      telefono2Tipo: '',
      telefono2: '',
      corsi: [], 
      corsiRitirati: [],
      sesso: undefined,
    }

    this.grid = 2;

    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {
        isLoading: true, 
        isMobile: false,
    };

  }

  handleResize() {
      
      if (window.innerWidth < 700) {
        this.setState({ isMobile: true });
      } else {
        this.setState({ isMobile: false });
      }
  }

  async componentDidMount(){

    window.addEventListener('resize', this.handleResize());

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentStudente = cookies.get('currentStudente', { path: '/' });
    this.dbPath = cookies.get('db_path', { path: '/' });

    Utils.setAnalyticsPage('Student edit: ' + cookies.get('currentStudente', { path: '/' }) + ' - ' + cookies.get('db', { path: '/' }));

    var studente = undefined;
    this.studenti = await getStudenti(username, token);
    this.studenti.forEach(s => {
      if (s.id == currentStudente)
      studente = s;
    });
    
    this.corsi = await getCorsi(username, token);
    this.corsiArray = [];
    this.corsiUtente = [];
    this.corsiRitiratiArray = [];
    this.sessoArray = [];

    this.sessoArray.push({ value: 'M', label: t('M') });
    this.sessoArray.push({ value: 'F', label: t('F') });
    this.sessoArray.push({ value: 'A', label: t('A') });

    this.corsi.map(r => {
      this.corsiArray.push({value: r.id, label: r.name.replace(/\\/g, '').replace(/\\n/g, '')});
      
      // Map courses where student is signed in 
      studente.corsi.split(';').forEach(c => {
        if (c == r.id){
          this.corsiUtente.push({value: r.id, label: r.name.replace(/\\/g, '').replace(/\\n/g, '')});
        }
      });

      // Map courses where student is signed as retired 
      studente.corsi_ritiro.split(';').forEach((corso) => {
        if (corso == r.id) {
          this.corsiRitiratiArray.push({ value: r.id, label: r.name.replace(/\\/g, '').replace(/\\n/g, '') });
        }
      });
  });

    this.setState({
      corsiArray: this.corsiArray,
      corsiRitirati: this.corsiRitiratiArray,
      corsi: this.corsiUtente,
      studente: studente, 
      isLoading: false, 
      sessoArray: this.sessoArray, 
      sesso: { value: studente.sesso, label: t(studente.sesso) },
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize());
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />;
    if (this.state.studente == undefined) return <div />;

    return (
      <div >
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: () => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('modifica_studente')} />

        <div style={{ display: 'flex' }}>
          
          <div>
          <TextInput name={t('nome')} value={this.state.studente.nome} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                nome: text
              }
            }))}
          } />

          <TextInput name={t('cognome')} value={this.state.studente.cognome} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                cognome: text
              }
            }))}
          } />


          <FixButton title={t('invia_credenziali')} callback={async () => {
            if (window.confirm(t('conferma_invio_credenziali')) == false) return;

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
            const currentStudente = cookies.get('currentStudente', { path: '/' });
            const db = cookies.get('db', { path: '/' });
            var utente = await getUtente(username, token, 1, currentStudente);

            if (utente == undefined){
              Utils.showInfo(t('utente_n_definito'));
              return;
            }

            var loginUsername = utente.username;
            var loginPassword = utente.clear_password;
            var sec_token = utente.security_token;
            
            var indirizzi = '';
            var nomi = '';
            if (this.state.studente.mail != ''){
              indirizzi += this.state.studente.mail;
              nomi += this.state.studente.nome + ' ' + this.state.studente.cognome;
            }
            if (this.state.studente.mail2 != ''){
              if (indirizzi != '') indirizzi += '---';
              if (nomi != '') nomi += '---';

              indirizzi += this.state.studente.mail2;
              nomi += this.state.studente.nome + ' ' + this.state.studente.cognome;
            }

            this.mail = await getSetting(username, token, 'sendingMailAddress');
            if (this.mail === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }
            this.mailName = await getSetting(username, token, 'sendingMailPassword');
            if (this.mailName === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }
            this.cliente = await getClient('', '', db);

            const subject = 'Invio credenziali ' + this.cliente.ragioneSociale;
            var body = studentCredenzialiMail(loginUsername, loginPassword, this.cliente.ragioneSociale, db, sec_token, this.state.studente.sesso);

            await sendMail(username, token, this.mail, this.mailName, indirizzi, nomi, '', subject, body);

          }} />

          <div key={Math.random()}>
            <SelectInput 
                ref={this.selectRef}
                value={this.state.sesso} 
                name={t('sesso')} 
                hidable={false}
                options={this.state.sessoArray} 
                onChange={(option) => 
                    this.setState({ sesso: option })} 
                />
          </div>

          <div key={Math.random()}>
            <SelectInput 
                ref={this.selectRef}
                value={this.state.corsi} 
                name={t('corsi')} 
                hidable={false}
                options={this.state.corsiArray} 
                isMulti={true}
                onChange={(option) => 
                    this.setState({corsi: option})} 
                />
          </div>

          <div key={Math.random()}>
            <SelectInput 
                ref={this.selectCoursesRitiratiRef}
                value={this.state.corsiRitirati} 
                name={t('corsi_ritiro')} 
                hidable={false}
                options={this.state.corsi} 
                isMulti={true}
                onChange={(option) => 
                    this.setState({ corsiRitirati: option })} 
                />
          </div>

          <TextInput name={'Mail'} value={this.state.studente.mail} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                mail: text
              }
            }))}
          } />
          <TextInput name={'Mail 2'} value={this.state.studente.mail2} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                mail2: text
              }
            }))}
          } />  

          </div>

          <div style={{ marginLeft: this.state.isMobile ? 0 : 20 }}>

          <TextInput name={t('indirizzo')} value={this.state.studente.indirizzo} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                indirizzo: text
              }
            }))}
          } />
          <TextInput name={t('citta')} value={this.state.studente.citta} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                citta: text
              }
            }))}
          } />
          <TextInput name={t('codice_fiscale')} value={this.state.studente.codiceFiscale} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                codiceFiscale: text
              }
            }))}
          } />
          <TextInput name={t('telefono')} value={this.state.studente.telefono} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                telefono: text
              }
            }))}
          } />
          <TextInput name={t('telefono') + '2'} value={this.state.studente.telefono2} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                telefono2: text
              }
            }))}
          } />
          <TextInput name={t('telefono_note')} value={this.state.studente.telefono2_tipo} 
            onChange={(text) => { this.setState(prevState => ({
              studente: {
                ...prevState.studente,           
                telefono2_tipo: text
              }
            }))}
          } />
            </div>
          </div>
          <FixButton title={t('salva')} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </div>
    );
  }

  async save () {
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });

      var strCorsiRitirati = "";
      this.state.corsiRitirati && this.state.corsiRitirati.forEach((corso) => {
        strCorsiRitirati += corso.value + ";";
      });

      var strCorsi = "";
      this.state.corsi && this.state.corsi.forEach(c => {
          strCorsi += c.value + ";";
      });

      await updateCorsiStudente(username, token, this.state.studente.id, strCorsi);
      await updateCorsiRitiroStudente(username, token, this.state.studente.id, strCorsiRitirati);

      let ret = await updateStudente (username, token, this.state.studente.id, this.state.studente.cognome, this.state.studente.nome, this.state.sesso.value, this.state.studente.mail, this.state.studente.mail2Tipo, this.state.studente.mail2, 
        this.state.studente.indirizzo, this.state.studente.citta, this.state.studente.codiceFiscale, this.state.studente.telefono, this.state.studente.telefono2_tipo, this.state.studente.telefono2);

      if (ret.result == 'ok'){
        window.location.href =  '/' + this.dbPath + '/#/app/studenti';
      } else {
        Utils.showError (t('errore_studente'))
      }
      
  }

}

